import React from "react";

import { Chip } from "@hdir/ui/chip";

type HighlightedWrapperProps = {
  children: React.ReactNode;
  display?: boolean;
  text: string
};

/**
 * Wrapper that overlays a chip with text in the top-right corner of its children.
 * @param display - If false, renders nothing. Defaults to true.
 * @param text - Text to be displayed. String
 */
export default function HighlightedWrapper({ children, display = true, text }: Readonly<HighlightedWrapperProps>) {
  if (!display) return null;

  return (
    <div className="relative">
      {/* Reserves space to the right on heading tags so card titles don't render underneath the chip */}
      <div className="[&_:is(h1,h2,h3,h4,h5,h6)]:pr-[6rem]">
        {children}
      </div>
      <div className="absolute top-3 right-3 z-10">
        <Chip className="!text-md">
          {text}
        </Chip>
      </div>
    </div>
  );
}
